module.exports = __webpack_public_path__ + "static/media/ico_my_stay.116cf953.svg";